export const TOP_BAR_ITEM_SIZE = 12;
